export enum ProgressAction {
    ADD = "ADD",
    REMOVE = "REMOVE"
}
export enum ProgressToggle {
    SIGNUP = "SIGNUP",
    INSURANCE = "INSURANCE",
    PRIVACY = "PRIVACY"
}